define('app/sf/aggregate/filter/sf-aggregate-filter-factory',["$rootScope"], function ($rootScope) {
	var Item = {
		valueOf: function () {
			return this.effective;
		},
		toString: function () {
			return this.valueOf().toString();
		},
		toLocaleString: function () {
			return this.valueOf().toLocaleString();
		}
	};

	function getAggregate(input, expression) {
		var getValue;
		var values = [];
		if (expression) {
			getValue = $rootScope.$eval.bind($rootScope, expression);
		}
		else {
			getValue = function (item) { return item; };
		}
		getValue = (function () {
			var _getValue = getValue;
			return function (item, key) {
				return angular.extend(Object.create(Item), {
					actual: item,
					effective: _getValue(item),
					key: key
				});
			};
		}());
		if (!angular.isObject(input)) {
			if (angular.isUndefined(input) || input === null) {
				return [];
			}
			else {
				return [getValue(input)];
			}
		}

		angular.forEach(input, function (value, key) {
			values.push(getValue(value, key));
		});
		return values;
	}

	function Aggregate(defaultOnSingle, defaultOnEmpty, processor) {
		if (!(this instanceof Aggregate)) {
			return new Aggregate(processor);
		}

		switch (arguments.length) {
			case 3:
				break;
			case 2:
				processor = defaultOnEmpty;
				defaultOnEmpty = true;
				break;
			case 1:
				processor = defaultOnSingle;
				defaultOnSingle = true;
				defaultOnEmpty = true;
				break;
			default:
				defaultOnSingle = true;
				defaultOnEmpty = true;
				processor = function (aggregateValues) { return aggregateValues; };
		}



		return function (input, expression, valueToReturn) {
			var values = getAggregate(input, expression);
			if (!values.length && defaultOnEmpty) {
				return undefined;
			}
			if (values.length === 1 && defaultOnSingle) {
				return values[0];
			}

			var result = processor(values);
			switch (valueToReturn) {
				case "effective":
					return result.effective;
				case "actual":
					return result.actual;
				default:
					if (valueToReturn) {
						return result;
					}
					else {
						return result.effective;
					}
			}
		};
	}
	Aggregate.Item = Item;
	return Aggregate;
});
